The value that was provided for the field.

For example, "this is not a valid city".
